export const HOUSING_PROGRAM_OPTIONS = {
  HIS: "HIS",
  HMP: "HMP",
} as const;

export type HousingProgramValue =
  (typeof HOUSING_PROGRAM_OPTIONS)[keyof typeof HOUSING_PROGRAM_OPTIONS];

/** Form sentinel — cleared selections map to null on the API. */
export const HOUSING_PROGRAM_NONE = "";

export const HOUSING_PROGRAM_CHOICES = [
  { value: HOUSING_PROGRAM_NONE, label: "Nenhum" },
  { value: HOUSING_PROGRAM_OPTIONS.HIS, label: "HIS" },
  { value: HOUSING_PROGRAM_OPTIONS.HMP, label: "HMP" },
] as const;

const HOUSING_PROGRAM_LABELS: Record<HousingProgramValue, string> = {
  [HOUSING_PROGRAM_OPTIONS.HIS]:
    "HIS — Habitação de Interesse Social",
  [HOUSING_PROGRAM_OPTIONS.HMP]:
    "HMP — Habitação de Mercado Popular",
};

export function normalizeHousingProgramFromApi(raw: unknown): string {
  if (raw === HOUSING_PROGRAM_OPTIONS.HIS || raw === HOUSING_PROGRAM_OPTIONS.HMP) {
    return raw;
  }

  return HOUSING_PROGRAM_NONE;
}

export function normalizeHousingProgramForApi(
  raw: unknown
): HousingProgramValue | null {
  if (raw === HOUSING_PROGRAM_OPTIONS.HIS || raw === HOUSING_PROGRAM_OPTIONS.HMP) {
    return raw;
  }

  return null;
}

export function formatHousingProgramLabel(raw: unknown): string | null {
  if (raw === HOUSING_PROGRAM_OPTIONS.HIS || raw === HOUSING_PROGRAM_OPTIONS.HMP) {
    return HOUSING_PROGRAM_LABELS[raw];
  }

  return null;
}
